import React from "react";
import Context from "../../Context";
import { Modal } from "react-bootstrap";
import Blocker from "./Blocker";
import { getTypedocByKey } from "./../Layout/Workdoc/typedoc";
import Flex from "./Flex";
import Searchbox from "./Searchbox";
import DefaultNotFound from "./DefaultNotFound";

export default class DocumentPicker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      items: [],
      valueItem: {},
      value: this.props.defaultValue,
      modal: false,
      searchText: "",
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setState({ value: this.props.defaultValue }, () => this.load());
    }
  }

  hasManageRights = () => {
    let access = this.context.user.classAccess[this.props.essence] || {};
    if (access.c || access.u || access.d) {
      return true;
    }
    return false;
  };

  load = async () => {
    this.setState({ pending: true });
    let valueItem = {};
    if (this.state.value) {
      valueItem = await this.context.api.q(`/document/get`, {
        id: this.state.value,
        fields: ["id", "label"],
      });
    }
    this.setState({ valueItem: valueItem || {}, pending: false });
  };

  loadList = async () => {
    this.setState({ pending: true });
    let search = [];

    if (this.state.searchText) {
      search.push({
        lstr: "(",
        field: "label",
        compare: "IKE",
        value: `%${this.state.searchText}%`,
        rstr: ")",
      });
    }

    if (this.props.classes) {
      search.push({
        lstr: "(",
        field: "classcode",
        valarr: this.props.classes,
        rstr: ")",
      });
    }
    if (this.props.states) {
      search.push({
        lstr: "(",
        field: "statetypecode",
        valarr: this.props.states,
        rstr: ")",
      });
    }

    let items = await this.context.api.qa(`/document/list`, {
      reclimit: 50,
      orderby: ["created DESC", "label ASC"],
      search,
      fields: ["id", "label", "created", "classcode", "areaname"],
    });
    this.setState({ items, pending: false });
  };

  openModal = () => {
    this.loadList();
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  onChange = (document) => {
    if (this.props.onChange) {
      this.props.onChange(document.id, document);
    }
    this.closeModal();
  };

  onSearch = (text) => {
    this.setState({ searchText: text }, () => this.loadList());
  };

  render() {
    const { pending, valueItem, modal, items } = this.state;
    const { nameField } = this.props;

    let input = (
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          value={valueItem[nameField || "label"] || ""}
          onDoubleClick={this.openModal}
          readOnly
        />
        <div className="input-group-append">
          {pending ? (
            <div className="btn btn-icon border">
              <span
                className="spinner-border spinner-border-sm text-muted"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            <button
              title="Выбрать"
              className="btn btn-icon border"
              type="button"
              onClick={this.openModal}
            >
              <i className="fa icon-md text-muted fa-navicon"></i>
            </button>
          )}
        </div>
      </div>
    );

    if (this.props.input) {
      input = <div onClick={this.openModal}>{this.props.input}</div>;
    }

    return (
      <>
        {modal && (
          <Modal size="lg" show onHide={this.closeModal}>
            <Modal.Header closeButton>
              <Modal.Title className="w-100">
                <Searchbox
                  defaultText={this.state.searchText}
                  onSearch={this.onSearch}
                />
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Blocker on={pending}>
                {items.length === 0 && <DefaultNotFound />}
                {items.map((item, idx) => {
                  let document = item || {};
                  let typedoc = getTypedocByKey(item.classcode);

                  const date = document.created
                    ? new Date(document.created)
                    : {};

                  return (
                    <div
                      key={idx}
                      className="border-bottom   py-4 cursor-pointer bg-hover-light"
                      onDoubleClick={() => this.onChange(document)}
                    >
                      <Flex between>
                        <div>
                          <span
                            className={`svg-icon mr-2 opacity-50 svg-icon-${typedoc.iconColor}`}
                          >
                            {typedoc.icon}
                          </span>
                          {document.label}
                        </div>
                        <div className="text-right">
                          <div className="text-dark-50 small">
                            {date.toLocaleString()}
                          </div>
                          <div className="text-dark-50 small">
                            {document.areaname}
                          </div>
                        </div>
                      </Flex>
                    </div>
                  );
                })}
              </Blocker>
            </Modal.Body>
          </Modal>
        )}
        {input}
      </>
    );
  }
}
